import { Link } from "react-router-dom";
import { MapPin, Phone, Clock, Instagram } from "lucide-react";

function TikTokIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
      <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 0010.86 4.46V12.8a8.28 8.28 0 005.58 2.17V11.5a4.85 4.85 0 01-3.77-1.58V6.69h3.77z" />
    </svg>
  );
}

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#0B0B0F] border-t border-[#C9A227]/15">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <img src="https://customer-assets.emergentagent.com/job_937fb50f-6c1c-4cbe-8cbd-a98f08545350/artifacts/u5a3eo6l_PNG-05.png" alt="Sheesh Eatery & Lounge" className="h-14 w-auto mb-4" />
            <p className="text-white/50 text-sm leading-relaxed mb-6">
              Dallas's premier hookah lounge & dining destination. Where luxury meets flavor.
            </p>
            <div className="flex gap-4">
              <a href="https://instagram.com/sheeshtx" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-[#C9A227]/30 flex items-center justify-center text-[#C9A227]/60 hover:bg-[#C9A227] hover:text-black transition-all">
                <Instagram size={16} />
              </a>
              <a href="https://tiktok.com/@sheeshtx" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-[#C9A227]/30 flex items-center justify-center text-[#C9A227]/60 hover:bg-[#C9A227] hover:text-black transition-all">
                <TikTokIcon size={16} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Explore</h4>
            <div className="space-y-3">
              {[{to:"/menu",l:"Our Menu"},{to:"/events",l:"Events"},{to:"/catering",l:"Catering"},{to:"/franchise",l:"Franchise"}].map(({to,l}) => (
                <Link key={to} to={to} className="block text-white/50 text-sm hover:text-[#C9A227] transition-colors">{l}</Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Visit Us</h4>
            <div className="space-y-4 text-sm text-white/50">
              <div className="flex items-start gap-3">
                <MapPin size={16} className="text-[#C9A227] mt-0.5 shrink-0" />
                <span>Dallas, TX</span>
              </div>
              <div className="flex items-start gap-3">
                <Phone size={16} className="text-[#C9A227] mt-0.5 shrink-0" />
                <a href="tel:+12144077941" className="hover:text-[#C9A227] transition-colors">+1 (214) 407-7941</a>
              </div>
              <div className="flex items-start gap-3">
                <Clock size={16} className="text-[#C9A227] mt-0.5 shrink-0" />
                <div>
                  <p>Sun - Thu: 11 AM - 2 AM</p>
                  <p>Fri - Sat: 11 AM - 3 AM</p>
                </div>
              </div>
            </div>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Follow Us</h4>
            <div className="space-y-3 text-sm">
              <a href="https://instagram.com/sheeshtx" target="_blank" rel="noreferrer" className="flex items-center gap-3 text-white/50 hover:text-[#C9A227] transition-colors">
                <Instagram size={16} className="text-[#C9A227]" />
                @Sheeshtx
              </a>
              <a href="https://tiktok.com/@sheeshtx" target="_blank" rel="noreferrer" className="flex items-center gap-3 text-white/50 hover:text-[#C9A227] transition-colors">
                <TikTokIcon size={16} />
                @Sheeshtx
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs">&copy; {new Date().getFullYear()} Sheesh Eatery & Lounge. All rights reserved.</p>
          <p className="text-white/20 text-xs">Designed with passion in Dallas, TX</p>
        </div>
      </div>
    </footer>
  );
}
